module.exports = __webpack_public_path__ + "static/media/x2014_11_06_1_13_b.jpg.pagespeed.ic.lhkWGGJSiE.938bf867.jpg";